import React from 'react';
import TempApp from './components/Temp/TempApp';

const App = () => {
  return (
    <TempApp/>
  )
}

export default App;